import styled from '@emotion/styled'

export const FunkyContainer = styled.div`

    padding: 2rem;
    position: relative;
    margin-top: -2rem;

    z-index: -1;
    svg {
      margin-top: -2rem;
      margin-left: -2rem;
    }
    h2 {
      transform: rotate(-2deg);
    }
    > *:not(svg){
        position: relative;
        text-align: center;
        margin-bottom: 0;
    }

`

export const StyledSVG = styled.svg`
  position: absolute;
  height: 100%;
  width: 100%;
`